import React, { useEffect, useState } from 'react'
import AudioSettings from "../../../assets/ai-tutor/audio-settings.svg";
import {
    Menu, MenuButton, MenuList, MenuItem, Image, useBreakpointValue, VStack, Box,
    HStack, Portal
} from '@chakra-ui/react'
import { useRoot } from '../../../context/RootContext';
import { arrStringToArrayObj, TTS_MODELS, TTS_TYPES, TTS_VOICES } from '../../../utils/playground-constants';
import Dropdown from '../../organisms/ai-tutor/Dropdown'
import { getTTSVoiceByModel } from '../../../network/TutorApiService';
import { isEmptyOrNull } from '../../../utils/common-utils';

export default function ElevenLabsSwitch() {
    const isMobile = useBreakpointValue({ base: true, md: false, lg: false });
    const { ttsPlaygroundObj, setTtsPlaygroundObj,isSubjectLevelDoubt } = useRoot();
    const [models, setModels] = useState([]);
    const [voiceIds, setVoiceIds] = useState([]);


    const handleChangeType = async (value) => {
        const existingModels = TTS_MODELS[value] || [];
        setModels(existingModels)
        setTtsPlaygroundObj((prev) => ({ ...prev, tts_type: value, tts_model: existingModels?.[0]?.value || "" }));

        const { grade_id, subject_id, topic_name_id: topic_id, grade, subject, topic_name } = ttsPlaygroundObj;
        const body = {
          "type": value,
          grade_id, subject_id, topic_id, grade, subject, topic_name,
          version_id: isSubjectLevelDoubt ? "v2" : "v1",
        }
        const { data: voiceInfo } = await getTTSVoiceByModel(body);
        console.log(voiceInfo)
        if (isEmptyOrNull(voiceInfo)) {
            const existingVoices = TTS_VOICES[value] || []
            setVoiceIds(arrStringToArrayObj(existingVoices))
            setTtsPlaygroundObj((prev) => ({ ...prev, voice_id: existingVoices?.[0], caching_flag: 1 }));
        } else {
            const existingVoices = [voiceInfo] || []
            setVoiceIds(arrStringToArrayObj(existingVoices))
            setTtsPlaygroundObj((prev) => ({ ...prev, voice_id: existingVoices?.[0], caching_flag: 0 }));
        }
    }

    const { tts_model = "", tts_type = "", voice_id = "" } = ttsPlaygroundObj || {};
    return (
        <Menu>
            <MenuButton>
                <Image
                    src={AudioSettings}
                    width={isMobile ? "24px" : "38px"}
                    height={isMobile ? "24px" : "38px"}
                    cursor={"pointer"}
                    mr={isMobile ? 4 : 6}
                />
            </MenuButton>
            <Portal>
                <MenuList px={2} w={"360px"} bg={"white"} color="black" fontSize={"14px"} zIndex={9999} position="relative">
                    <VStack spacing={4} w={"100%"} alignItems={"flex-start"}>
                        <HStack w="100%" justifyContent={"flex-end"}>
                            <Box sx={{ color: "#372578", fontWeight: "600", fontSize: "14px", mb: 1 }}>Type :</Box>
                            <Box w={"70%"}>
                                <Dropdown
                                    placeholder={"select type"}
                                    value={tts_type}
                                    setValue={handleChangeType}
                                    data={arrStringToArrayObj(TTS_TYPES)}
                                />
                            </Box>
                        </HStack>
                        {models?.length > 0 &&
                            <HStack w="100%" justifyContent={"flex-end"}>
                                <Box sx={{ color: "#372578", fontWeight: "600", fontSize: "14px", mb: 1 }}>Model :</Box>
                                <Box w={"70%"}>
                                    <Dropdown
                                        placeholder={"select model"}
                                        value={tts_model}
                                        setValue={(val) => setTtsPlaygroundObj(prev => ({ ...prev, tts_model: val }))}
                                        data={models}
                                    />
                                </Box>
                            </HStack>
                        }
                        {voiceIds?.length > 0 &&
                            <HStack w="100%" justifyContent={"flex-end"}>
                                <Box sx={{ color: "#372578", fontWeight: "600", fontSize: "14px", mb: 1 }}>Voice Id :</Box>
                                <Box w={"70%"}>
                                    <Dropdown
                                        placeholder={"select voice"}
                                        value={voice_id}
                                        setValue={(val) => setTtsPlaygroundObj(prev => ({ ...prev, voice_id: val }))}
                                        data={voiceIds}
                                    />
                                </Box>
                            </HStack>
                        }
                    </VStack>
                </MenuList>
            </Portal>
        </Menu>
    )
}
